import { Dropdown } from '../../Dropdown';
import { IconButton } from '../../IconButton';
import { Icons } from '../../Icons';
import { ColumnSortUI, CustomColumnDef } from '../types';

interface ColumnOptionsPopoverProps<TData, TValue> {
  columnDef: CustomColumnDef<TData, TValue>;
  onSortAsc: () => void;
  onSortDesc: () => void;
  onHideColumn: () => void;
}

type MetaWithSortUi = { sortUi?: ColumnSortUI } | undefined;
type IconType = typeof Icons.ArrowUp;

export function ColumnOptionsPopover<TData, TValue>({
  columnDef,
  onSortAsc,
  onSortDesc,
  onHideColumn,
}: ColumnOptionsPopoverProps<TData, TValue>) {
  const metaSortUi = (columnDef.meta as MetaWithSortUi)?.sortUi;
  const sortUi = columnDef.sort?.ui;

  const isIconComponent = (x: unknown): x is IconType =>
    typeof x === 'function';
  const labelFrom = (node: unknown, fallback: string): string =>
    typeof node === 'string' ? node : fallback;

  return (
    <Dropdown
      menu={{
        groups: [
          {
            items: [
              {
                label: labelFrom(
                  metaSortUi?.asc?.columnNode ?? sortUi?.asc?.columnNode,
                  'Sort alphabetically: A–Z'
                ),
                icon: isIconComponent(metaSortUi?.asc?.icon)
                  ? metaSortUi?.asc?.icon
                  : isIconComponent(sortUi?.asc?.icon)
                    ? sortUi?.asc?.icon
                    : Icons.ArrowUp,
                onClick: onSortAsc,
              },
              {
                label: labelFrom(
                  metaSortUi?.desc?.columnNode ?? sortUi?.desc?.columnNode,
                  'Sort alphabetically: Z–A'
                ),
                icon: isIconComponent(metaSortUi?.desc?.icon)
                  ? metaSortUi?.desc?.icon
                  : isIconComponent(sortUi?.desc?.icon)
                    ? sortUi?.desc?.icon
                    : Icons.ArrowDown,
                onClick: onSortDesc,
              },
              {
                label: 'Hide column',
                icon: Icons.EyeOff,
                onClick: onHideColumn,
              },
            ],
          },
        ],
      }}
      align="end"
    >
      <IconButton
        icon={<Icons.DotsHorizontal className="size-4" />}
        aria-label="Column options"
        size="sm"
      />
    </Dropdown>
  );
}
